import { CourseKeyword } from '@shared/types';
import { ButtonLink } from 'components/_ui/Buttons';
import { FunctionComponent } from 'react';
import styles from './styles.module.scss';
import { Temporal } from 'temporal-polyfill';

type ExpiredContentWarningProps = {
    courseKeyword: CourseKeyword;
    recordType: 'booking' | 'order';
    receiptLink: string;
    courseLink: string;
    contactLink: string;
    expiryDate: Temporal.ZonedDateTime;
};
const ExpiredContentWarning: FunctionComponent<ExpiredContentWarningProps> = ({
    courseKeyword,
    recordType,
    receiptLink,
    courseLink,
    contactLink,
    expiryDate,
}) => {
    return (
        <div className={styles.expiredContentWarning}>
            <h2>Access Expired</h2>
            <p>Your access to this {courseKeyword} has expired.</p>
            <p>
                <>
                    Your access to this {courseKeyword} ended on{' '}
                    {expiryDate.toLocaleString(undefined, {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                    })}
                    .
                </>
            </p>
            <p>
                To regain access, you can re-enroll in the {courseKeyword} or contact the{' '}
                {courseKeyword} provider for further assistance.
            </p>
            <div className={styles.buttonGroup}>
                <ButtonLink appearance="primary" to={receiptLink}>
                    Back to {recordType}
                </ButtonLink>
                <ButtonLink appearance="outlined" to={courseLink}>
                    Re-enroll Now
                </ButtonLink>
                <ButtonLink appearance="outlined" to={contactLink}>
                    Contact Educator
                </ButtonLink>
            </div>
        </div>
    );
};

export default ExpiredContentWarning;
